import React, { useEffect, useRef, useState } from "react";
import { Card, Space, AutoComplete, Button  } from 'antd';
import { EditOutlined, EllipsisOutlined, SettingOutlined } from '@ant-design/icons';
import { Link, useHistory } from "react-router-dom";
import "../ECatalogComponents/productslide.css";

import Slider from "react-slick";
import { FaAngleLeft, FaAngleRight } from "react-icons/fa";
import { BsCartPlus } from "react-icons/bs";
//import { useCart } from 'react-use-cart';
import ProductItem from "./ProductItem";
import { SearchCatalogItem } from "../../Services/e-pro/EcatalogService";
import { IProductItem } from "../../IRequestModel/ECatalog/IProductItemModel";
import { GetViewItemFromLocalStorage } from "../../Helper/ECatalogHelper";

const { Meta } = Card;

interface Props {
    // showSlide: boolean,
    // limitItem?: number
}

export default  function LatestViewProduct (props: Props) {
    const [products, setProducts] = useState<IProductItem[]>([]);
    const customSlider = useRef<Slider>(null);
    //const { addItem, emptyCart } = useCart();
    const history = useHistory();
    useEffect(() => {
        var itemProduct = GetViewItemFromLocalStorage();
        itemProduct.sort((a, b) => {
            if (a.stampdate < b.stampdate) {
                return -1;
            }
            if (a.stampdate > b.stampdate) {
                return 1;
            }
            return 0;
        });
        setProducts(itemProduct.slice(0, 5));
    }, [])


   
    var settings = {
        /*rows: 2,*/
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 5,
        slidesToScroll: 1,
        /*initialSlide: 6,*/
        prevArrow: <FaAngleLeft />,
        nextArrow: <FaAngleRight/>,
        variableWidth: true,
        responsive: [
            
        {
            breakpoint: 1024,
            settings: {
              slidesToShow: 3,
            }
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 3,
            }
          },
           {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
            }
          }
        ]
      };

    return (
        <>
        <div style={{width: "100%", padding:"0px 20px" }}>
        {
            // <Slider ref={customSlider} {...settings} className="slider-product">
                 <Space style={{ display: "flex" }} wrap> 
                    {
                            
                            products.map(product => (
                            
                                <>
                                    <ProductItem product={product}></ProductItem>
                                </>
                            ))
                        }
                </Space> 
            // </Slider>
        }
        
            

        </div>
           
            
        </>
    )
};